import PageContents, { PageContentsProps } from './PageContents';

export default PageContents;
export type { PageContentsProps };
